import mapboxgl from 'mapbox-gl';

// Mapbox access token
mapboxgl.accessToken = 'pk.eyJ1IjoibHVrZTc0OTYiLCJhIjoiY200ZWhid3ZzMHdqZjJqczgxOXZ2dGxicSJ9.JblzpGdX_6SFCTNdZ0SWgw';

// Map configuration
export const mapConfig = {
  style: 'mapbox://styles/mapbox/dark-v10',
  defaultCenter: [-0.085, 51.512] as [number, number],
  defaultZoom: 14,
};